<template>
  <section>
    <v-container fluid class="fill-height relative" :key="componentKey">
      <v-row dense class="fill-height">
        <v-col cols="12" lg="4" id="chatListPanel">
          <v-row dense>
            <v-col cols="12">
              <v-card flat>
                <v-container>
                  <v-row no-gutters align="center">
                    <v-col cols="12" style="min-width: 100px; max-width: 100%;" class="flex-grow-1 flex-shrink-0">
                      <v-row dense align="center" justify="space-between">
                        <v-col cols="6">
                          <v-btn small block color="success" elevation="0" @click="gotToContacts()">
                            Nuevo
                          </v-btn>
                        </v-col>

                        <v-col cols="2">
                          <v-tooltip bottom>
                            <template v-slot:activator="{ on, attrs }">
                              <v-btn
                                small
                                block
                                outlined
                                v-bind="attrs"
                                v-on="on"
                                color=""
                                @click="toggleQuickMsgDialog"
                              >
                                <v-icon>
                                  mdi-message-text-fast
                                </v-icon>
                              </v-btn>
                            </template>
                            <span>Mensaje Rápido</span>
                          </v-tooltip>
                        </v-col>

                        <v-col cols="2">
                          <v-tooltip bottom>
                            <template v-slot:activator="{ on, attrs }">
                              <v-btn small block outlined v-bind="attrs" v-on="on" color="" @click="refreshComponent">
                                <v-icon>
                                  mdi-reload
                                </v-icon>
                              </v-btn>
                            </template>
                            <span>Recargar</span>
                          </v-tooltip>
                        </v-col>

                        <v-col cols="2">
                          <v-menu bottom left>
                            <template v-slot:activator="{ on, attrs }">
                              <v-btn small block outlined v-bind="attrs" v-on="on">
                                <v-icon>
                                  mdi-filter-variant
                                </v-icon>
                              </v-btn>
                            </template>

                            <v-list dense>
                              <v-list-item
                                v-for="item in queueItemsFilter"
                                :key="item.id"
                                @change="filterChats(item.id)"
                                style="cursor: pointer"
                              >
                                <v-list-item-title>
                                  {{ item.name }}
                                </v-list-item-title>
                              </v-list-item>
                            </v-list>
                          </v-menu>
                        </v-col>

                        <v-col cols="10" style="min-width: 100px;" class="flex-grow-1 flex-shrink-0 my-2">
                          <v-text-field
                            v-model="search"
                            label="Buscar..."
                            prepend-inner-icon="mdi-magnify"
                            class="rounded-small"
                            clearable
                            dense
                            outlined
                            hide-details
                            @click:clear="onClearSearch"
                            @keyup.enter="onSearch"
                          />
                        </v-col>

                        <v-col cols="2">
                          <v-tooltip bottom>
                            <template v-slot:activator="{ on, attrs }">
                              <v-btn block outlined v-bind="attrs" v-on="on" color="" @click="isOpenSearch = true">
                                <v-icon>
                                  mdi-history
                                </v-icon>
                              </v-btn>
                            </template>
                            <span>Historial</span>
                          </v-tooltip>
                        </v-col>

                        <v-col cols="12">
                          <v-expand-transition>
                            <v-chip-group
                              v-if="tabChats === 0"
                              v-model="readFilter"
                              mandatory
                              active-class="primary--text"
                              @change="onFilterChange"
                            >
                              <v-chip outlined class="mr-1" :value="0">
                                Todos
                              </v-chip>

                              <v-chip outlined class="mr-1" :value="1">
                                Leído
                              </v-chip>

                              <v-chip outlined class="mr-1" :value="2">
                                No leído
                              </v-chip>
                            </v-chip-group>
                          </v-expand-transition>
                        </v-col>
                      </v-row>
                    </v-col>
                  </v-row>
                </v-container>
              </v-card>
            </v-col>

            <v-col cols="12">
              <v-card flat>
                <v-tabs v-model="tabChats" background-color="transparent" color="primary" grow>
                  <v-tab @click="getActiveChats()">
                    Activos

                    <v-btn
                      v-if="!!totalActiveChats"
                      fab
                      x-small
                      width="24"
                      height="24"
                      :color="totalActiveChats ? 'success white--text' : 'grey lighten-2'"
                      class="elevation-0 ml-2"
                    >
                      <!-- <span v-if="[3].includes(Role)" class="text-medium"> -->
                      <span class="text-medium">
                        {{ totalActiveChats }}
                      </span>
                    </v-btn>
                  </v-tab>

                  <v-tab>
                    Pendientes

                    <v-btn
                      v-if="!!totalQueueChats"
                      fab
                      x-small
                      width="24"
                      height="24"
                      :color="totalQueueChats ? 'success white--text' : 'grey lighten-2'"
                      class="elevation-0 ml-2"
                    >
                      <!-- <span v-if="[3].includes(Role)" class="text-medium"> -->
                      <span class="text-medium">
                        <!-- {{ totalQueueChats }} -->
                        {{ queueCount }}
                      </span>
                    </v-btn>
                  </v-tab>
                </v-tabs>

                <v-tabs-items v-model="tabChats">
                  <v-tab-item>
                    <active-chats-section
                      :search="search"
                      :chatList="activeChatsList"
                      :totalChats="totalActiveChats"
                      :historyIsActive="historyIsActive"
                      :isLoading="isLoading"
                      @chat:preview="chatPreview"
                      @close:history="closeHistoryPanel"
                      :isLoadingMore="isLoadingMoreActive"
                      @load:more="loadMoreActiveChats"
                    >
                    </active-chats-section>
                  </v-tab-item>

                  <v-tab-item>
                    <pending-chats-section
                      v-show="!historyIsActive"
                      :search="search"
                      :isLoading="isLoading"
                      :chatList="queueChatsList"
                      :totalChats="totalQueueChats"
                      @chat:accept="aceptChat"
                      @close:history="closeHistoryPanel"
                      :isLoadingMore="isLoadingMoreQueue"
                      @load:more="loadMoreQueueChats"
                    ></pending-chats-section>
                  </v-tab-item>
                </v-tabs-items>
              </v-card>
            </v-col>
          </v-row>
        </v-col>

        <v-col cols="12" lg="8" id="chatViewPanel" :class="isMobile ? 'd-none' : ''">
          <v-toolbar flat class="mb-5">
            <template v-if="dataUserActiveChat.id !== null">
              <v-btn v-if="isMobile" small class="mr-1" icon @click="closeChatPanelOnMobile">
                <v-icon>mdi-arrow-left</v-icon>
              </v-btn>
              <v-list-item :dense="isMobile" class="pl-0">
                <v-list-item-avatar
                  size="40"
                  :color="$vuetify.theme.dark ? 'blue-grey darken-4' : 'blue-grey lighten-5'"
                >
                  <img v-if="dataUserActiveChat.avatar" :src="dataUserActiveChat.avatar" alt="Avatar del usuario" />
                  <v-icon color="blue-grey" v-else>mdi-account</v-icon>
                </v-list-item-avatar>
                <template>
                  <v-list-item-content>
                    <v-list-item-title>
                      {{ dataUserActiveChat.name + getFormattedPhone(dataUserActiveChat) }}
                    </v-list-item-title>

                    <v-list-item-subtitle>Asignado a {{ userName }} </v-list-item-subtitle>
                  </v-list-item-content>
                </template>
              </v-list-item>

              <v-spacer></v-spacer>

              <v-menu bottom left :disabled="dataUserActiveChat.id == null ? true : false">
                <template v-slot:activator="{ on, attrs }">
                  <v-btn icon v-bind="attrs" v-on="on">
                    <v-icon>mdi-dots-vertical</v-icon>
                  </v-btn>
                </template>

                <v-list dense>
                  <!-- <v-list-item @click="openContactDetailsDialog()">
                  <v-list-item-title>Ver contacto</v-list-item-title>
                </v-list-item> -->

                  <v-list-item @click="handleChat('closed')">
                    <v-list-item-title>
                      Resolver
                    </v-list-item-title>
                  </v-list-item>

                  <v-list-item @click="handleChat('closedTip')">
                    <v-list-item-title>
                      Resolver y tipificar
                    </v-list-item-title>
                  </v-list-item>

                  <v-list-item @click="handleChat('pending')">
                    <v-list-item-title>Devolver</v-list-item-title>
                  </v-list-item>

                  <v-list-item @click="OpenAgentDialog('user')">
                    <v-list-item-title>Transferir a usuario</v-list-item-title>
                  </v-list-item>

                  <v-list-item @click="OpenAgentDialog('queue')">
                    <v-list-item-title>Transferir a cola</v-list-item-title>
                  </v-list-item>

                  <v-divider></v-divider>

                  <v-list-item @click="openContactDetailsDialog()">
                    <v-list-item-title>Ver perfil</v-list-item-title>
                  </v-list-item>

                  <v-list-item @click="isOpenSearch = true">
                    <v-list-item-title>Historial</v-list-item-title>
                  </v-list-item>

                  <v-divider></v-divider>

                  <v-list-item @click="openPreMessagesDialog()">
                    <v-list-item-title>Mensajes predefinidos</v-list-item-title>
                  </v-list-item>
                </v-list>
              </v-menu>
            </template>
          </v-toolbar>

          <v-card flat class="bg-chat" color="transparent">
            <v-layout
              row
              align-start
              align-content-start
              class="px-6"
              v-if="!isLoadingChat"
              ref="chatPreviewRef"
              :style="isReplyingMessage ? 'height: 50vh' : 'height: 61.5vh'"
            >
              <vuescroll
                ref="messageListVs"
                :ops="{
                  bar: {
                    background: '#bacfcec0',
                  },
                  scrollPanel: {
                    initialScrollY: '100%',
                    scrollingY: true,
                    speed: 300,
                  },
                }"
              >
                <!-- <v-container v-if="historyIsActive && allMessageShowed == false">
                <v-row justify="center">
                  <v-col cols="12" md="auto">
                    <v-btn
                      small
                      outlined
                      color="primary"
                      class=" mx-auto"
                      @click="userHistory()"
                    >
                      Ver más
                    </v-btn>
                  </v-col>
                </v-row>
              </v-container> -->

                <template v-for="items in messagesList">
                  <!-- <template v-for="item in messages"> -->
                  <template v-for="item in items">
                    <!-- FECHA -->
                    <!-- v-show="
                      shouldDisplayChip(item.created_at, identifier, index)
                    " -->
                    <v-container v-if="item.mediaType != 'reaction'" :key="item.id + '-date'">
                      <v-row justify="center">
                        <v-col cols="12" md="auto">
                          <v-chip label x-small class="ma-2">
                            {{ dateFormat(item.created_at) }}
                          </v-chip>
                        </v-col>
                      </v-row>
                    </v-container>

                    <v-menu
                      close-on-click
                      bottom
                      right
                      :key="`${item.id}-menu`"
                      max-width="200"
                      transition="slide-y-transition"
                    >
                      <template v-slot:activator="{ on, attrs }">
                        <div v-bind="attrs" v-on="on">
                          <!-- TEXTO -->
                          <template v-if="['chat'].includes(item.mediaType)">
                            <bubble-text
                              :message="item"
                              :NameClient="dataUserActiveChat.name"
                              :key="item.id + '-component'"
                            />
                          </template>

                          <!-- VCARD -->
                          <template v-if="item.mediaType === 'vcard'">
                            <bubble-vcard
                              :message="item"
                              :NameClient="dataUserActiveChat.name"
                              :key="item.id + '-component'"
                            />
                          </template>

                          <!-- IMAGE -->
                          <template v-if="item.mediaType === 'image' && !item.mediaUrl.endsWith('.pdf')">
                            <v-flex xs8 :offset-xs4="item.fromMe === 1" class="mb-2" :key="item.id" max-width="500">
                              <v-card
                                :dark="item.fromMe === 1"
                                class="shadow-2 message-bubble-wrapper"
                                :color="item.fromMe === 1 ? 'secondary' : ''"
                              >
                                <v-menu bottom left offset-y transition="slide-y-transition">
                                  <template v-slot:activator="{ on, attrs }">
                                    <v-btn icon x-small v-bind="attrs" v-on="on" class="message-menu-btn">
                                      <v-icon size="18">mdi-chevron-down</v-icon>
                                    </v-btn>
                                  </template>

                                  <v-list dense>
                                    <v-list-item @click="replyMessage(item)">
                                      <v-list-item-title>Responder</v-list-item-title>
                                    </v-list-item>
                                    <v-divider></v-divider>
                                    <v-list-item @click="deleteMessage(item.id)">
                                      <v-list-item-title>Eliminar</v-list-item-title>
                                    </v-list-item>
                                  </v-list>
                                </v-menu>
                                <v-card-text class="pb-1">
                                  <v-alert v-if="item.isDeleted === 1" dense colored-border type="info" :key="item.id">
                                    Mensaje eliminado.
                                  </v-alert>
                                  <br />

                                  <v-img
                                    :src="item.mediaUrl"
                                    :lazy-src="item.mediaUrl"
                                    class="grey lighten-2"
                                    max-width="500"
                                    style="cursor: pointer;"
                                    @click="photoPreview(item.id)"
                                  >
                                    <template v-slot:placeholder>
                                      <v-row class="fill-height ma-0" align="center" justify="center">
                                        <v-progress-circular indeterminate color="grey lighten-5"></v-progress-circular>
                                      </v-row>
                                    </template>
                                  </v-img>

                                  <v-btn
                                    outlined
                                    block
                                    color="primary"
                                    class="mt-2"
                                    @click="openImageModal(item.mediaUrl)"
                                  >
                                    Ver imagen
                                  </v-btn>

                                  <pre
                                    v-if="item.isDeleted !== 1"
                                    :class="item.fromMe === 1 ? 'white--text' : 'text--primary'"
                                    class="text--body-2 mb-1"
                                  >
                                    {{ item.body }}
                                  </pre>

                                  <span class="ml-n2">
                                    <small>{{ item.created_at | getHour12Format }}</small>
                                  </span>
                                </v-card-text>
                              </v-card>
                            </v-flex>
                          </template>

                          <!-- ARCHIVO -->
                          <template v-if="['file', 'document'].includes(item.mediaType)">
                            <bubble-file :message="item" :key="item.id + '-file'" />
                          </template>

                          <!-- VIDEO -->
                          <template v-if="item.mediaType === 'video'">
                            <v-flex xs8 offset-xs4 class="mb-1" :key="item.id" v-if="item.fromMe === 1">
                              <v-card dark class="shadow-2" color="secondary">
                                <v-card-text class="pb-1">
                                  <video
                                    controls
                                    width="220px"
                                    :src="item.mediaUrl"
                                    :poster="item.mediaUrl"
                                    aspect-ratio="1"
                                    class="grey lighten-2"
                                  ></video>

                                  <p v-if="item.body" class="text--primary text--body-2 mb-1">
                                    {{ item.body }}
                                  </p>

                                  <div>
                                    <span class="ml-n2">
                                      <v-icon v-if="item.ack >= 1" small :color="item.ack === 3 ? 'teal darken-1' : ''"
                                        >mdi-check</v-icon
                                      >
                                      <v-icon
                                        v-if="item.ack >= 2"
                                        small
                                        class="ml-n3"
                                        :color="item.ack === 3 ? 'teal darken-1' : ''"
                                        >mdi-check</v-icon
                                      >
                                    </span>
                                    <small>
                                      {{ item.created_at | getHour12Format }}
                                    </small>
                                  </div>
                                </v-card-text>
                                <v-avatar v-if="item.reaction" color="blue-grey darken-4" size="26" class="ml-1 mb-n3">
                                  {{ item.reaction }}
                                </v-avatar>
                              </v-card>
                            </v-flex>

                            <v-flex xs8 class="mb-1" :key="item.id" v-else-if="item.fromMe === 0">
                              <v-card class="shadow-2">
                                <v-card-text class="pb-1">
                                  <video
                                    controls
                                    width="220px"
                                    :src="item.mediaUrl"
                                    :poster="item.mediaUrl"
                                    aspect-ratio="1"
                                    class="grey lighten-2"
                                  ></video>

                                  <p v-if="item.body" class="text--primary text--body-2 mb-1">
                                    {{ item.body }}
                                  </p>

                                  <div>
                                    <span class="ml-n2">
                                      <v-icon v-if="item.ack >= 1" small :color="item.ack === 3 ? 'teal darken-1' : ''"
                                        >mdi-check</v-icon
                                      >
                                      <v-icon
                                        v-if="item.ack >= 2"
                                        small
                                        class="ml-n3"
                                        :color="item.ack === 3 ? 'teal darken-1' : ''"
                                        >mdi-check</v-icon
                                      >
                                    </span>
                                    <small>
                                      {{ item.created_at | getHour12Format }}
                                    </small>
                                  </div>
                                </v-card-text>
                                <v-avatar v-if="item.reaction" color="blue-grey darken-4" size="26" class="ml-1 mb-n3">
                                  {{ item.reaction }}
                                </v-avatar>
                              </v-card>
                            </v-flex>
                          </template>

                          <!-- VOICE -->
                          <template v-if="item.mediaType === 'ptt' || item.mediaType === 'audio'">
                            <v-flex
                              xs8
                              sm7
                              offset-xs4
                              offset-sm5
                              class="mb-1"
                              :key="item.id + '-audio'"
                              v-if="item.fromMe === 1"
                            >
                              <v-card dark class="shadow-2" color="secondary">
                                <v-card-text class="pb-1">
                                  <audio style="width:100%" controls>
                                    <source :src="item.mediaUrl" type="audio/ogg" />
                                  </audio>

                                  <!-- <p>{{ item.mediaUrl }}</p> -->
                                  <div>
                                    <span class="ml-n2">
                                      <v-icon v-if="item.ack >= 1" small :color="item.ack === 3 ? 'teal darken-1' : ''"
                                        >mdi-check</v-icon
                                      >
                                      <v-icon
                                        v-if="item.ack >= 2"
                                        small
                                        class="ml-n3"
                                        :color="item.ack === 3 ? 'teal darken-1' : ''"
                                        >mdi-check</v-icon
                                      >
                                    </span>
                                    <small>
                                      {{ item.created_at | getHour12Format }}
                                    </small>
                                  </div>
                                </v-card-text>
                                <v-avatar v-if="item.reaction" color="blue-grey darken-4" size="26" class="ml-1 mb-n3">
                                  {{ item.reaction }}
                                </v-avatar>
                              </v-card>
                            </v-flex>

                            <v-flex xs8 sm7 class="mb-1" :key="item.id + 'audio'" v-else-if="item.fromMe === 0">
                              <v-card class="shadow-2">
                                <v-card-text class="pb-1">
                                  <audio style="width:100%" controls>
                                    <source :src="item.mediaUrl" type="audio/ogg" />
                                  </audio>

                                  <!-- <p>{{ item.mediaUrl }}</p> -->

                                  <div>
                                    <span class="ml-n2">
                                      <v-icon v-if="item.ack >= 1" small :color="item.ack === 3 ? 'teal darken-1' : ''"
                                        >mdi-check</v-icon
                                      >
                                      <v-icon
                                        v-if="item.ack >= 2"
                                        small
                                        class="ml-n3"
                                        :color="item.ack === 3 ? 'teal darken-1' : ''"
                                        >mdi-check</v-icon
                                      >
                                    </span>
                                    <small>
                                      {{ item.created_at | getHour12Format }}
                                    </small>
                                  </div>
                                </v-card-text>
                                <v-avatar v-if="item.reaction" color="blue-grey darken-4" size="26" class="ml-1 mb-n3">
                                  {{ item.reaction }}
                                </v-avatar>
                              </v-card>
                            </v-flex>
                          </template>
                        </div>
                      </template>
                      <v-list dense>
                        <v-list-item @click="replyMessage(item)">
                          <v-list-item-title>Responder</v-list-item-title>
                        </v-list-item>
                        <v-divider></v-divider>
                        <v-list-item @click="deleteMessage(item.id)">
                          <v-list-item-title>Eliminar</v-list-item-title>
                        </v-list-item>
                      </v-list>
                    </v-menu>
                  </template>
                </template>
              </vuescroll>
            </v-layout>

            <v-layout row align-start align-content-start class="px-6" ref="chatPreviewRef" v-else> </v-layout>

            <v-card :disabled="historyIsActive" flat class="mt-6 pa-2">
              <v-alert
                v-if="isReplyingMessage"
                v-model="isReplyingMessage"
                elevation="0"
                text
                color="info"
                class="caption shadow-1"
                colored-border
                dismissible
                border="left"
                style="border-radius: 8px !important;"
                @input="onCloseReply"
              >
                <div>
                  <strong class="info--text">
                    {{ replyMessageContent.fromMe == 1 ? "Tú" : dataUserActiveChat.name }}
                  </strong>
                </div>
                <pre class="replyMessage text-left mb-0" v-if="replyMessageContent.mediaType == 'chat'">
                {{ replyMessageContent.body }}
              </pre
                >

                <v-img
                  v-else
                  :src="replyMessageContent.mediaUrl"
                  :lazy-src="replyMessageContent.mediaUrl"
                  class="grey lighten-2"
                  max-width="50"
                >
                  <template v-slot:placeholder>
                    <v-row class="fill-height ma-0" align="center" justify="center">
                      <v-progress-circular indeterminate color="grey lighten-5"></v-progress-circular>
                    </v-row>
                  </template>
                </v-img>
              </v-alert>

              <v-container fluid>
                <v-row align="center" align-content="center">
                  <div class="px-2">
                    <v-menu top center offset-y>
                      <!-- Activador: icono de tres puntos -->
                      <template v-slot:activator="{ on, attrs }">
                        <v-btn icon v-bind="attrs" v-on="on">
                          <v-icon>mdi-dots-vertical</v-icon>
                        </v-btn>
                      </template>

                      <!-- Contenido del menú -->
                      <v-list dense>
                        <!-- Switch Firmar -->
                        <v-list-item>
                          <v-list-item-content>
                            <v-list-item-title class="text-caption text--secondary">
                              Firmar
                            </v-list-item-title>
                          </v-list-item-content>

                          <v-list-item-action>
                            <v-switch v-model="firmaObligatoria" :disabled="canSign" color="success" dense />
                          </v-list-item-action>
                        </v-list-item>

                        <v-divider />

                        <!-- Botón Enviar mensaje -->
                        <v-list-item link clickable @click="enviarMensajeSolicitudArchivo(dataUserActiveChat.id)">
                          <v-list-item-title>
                            Solicitar archivo (enlace)
                          </v-list-item-title>
                        </v-list-item>
                      </v-list>
                    </v-menu>
                  </div>

                  <div>
                    <label for="fileInput" style="cursor: pointer;">
                      <v-icon size="24" class="mr-4">mdi-paperclip</v-icon>
                    </label>
                    <v-file-input
                      v-model="fileSelected"
                      id="fileInput"
                      ref="fileInput"
                      style="display: none"
                      truncate-length="15"
                      :disabled="isSendingMessage || historyIsActive"
                      accept="image/png, image/jpeg, image/bmp, .pdf, .doc,.docx,.xml,application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document, .csv, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"
                      @change="verifyFile"
                    ></v-file-input>
                  </div>

                  <v-file-input
                    v-if="fileExist"
                    v-model="fileSelected"
                    class="rounded-small"
                    prepend-icon=""
                    filled
                    rounded
                    show-size
                    clearable
                    hide-details
                    truncate-length="15"
                    :disabled="isSendingMessage || historyIsActive"
                    accept="image/png, image/jpeg, image/bmp, .pdf, .doc,.docx,.xml,application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document, .csv, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"
                    @change="verifyFile"
                  ></v-file-input>

                  <v-textarea
                    v-else
                    v-model="message"
                    id="typer-textarea"
                    style="width: 10% !important; max-height: 115px !important; overflow-y: auto;"
                    :dense="isMobile"
                    rows="1"
                    auto-grow
                    filled
                    rounded
                    class="rounded-small"
                    hide-details
                    placeholder="Escribir un mensaje..."
                    @keyup.enter="onEnterKey"
                    @keyup.alt.enter="insertNewLine"
                    @click:clear="clearMessage"
                    :disabled="isSendingMessage || historyIsActive"
                    @paste="handlePaste"
                  ></v-textarea>

                  <v-img v-if="imageSrc" :src="imageSrc" max-width="200" class="mt-3"></v-img>

                  <v-btn
                    v-if="fileExist"
                    large
                    icon
                    class="ml-2"
                    @click.enter="sendImage"
                    :disabled="isSendingMessage || historyIsActive"
                  >
                    <v-icon size="24">mdi-send</v-icon>
                  </v-btn>

                  <v-btn
                    v-else-if="message"
                    large
                    icon
                    class="ml-2"
                    @click.enter="sendMessage"
                    :disabled="isSendingMessage || historyIsActive"
                  >
                    <v-icon size="24">mdi-send</v-icon>
                  </v-btn>

                  <v-btn v-else large icon class="ml-2" @click="audioRecorderDialog = true">
                    <v-icon size="24">mdi-microphone</v-icon>
                  </v-btn>
                </v-row>
              </v-container>
            </v-card>
          </v-card>
        </v-col>

        <!-- <newTicketDialog
        v-if="newTicketDialog"
        :isActive="newTicketDialog"
        @dialog:close="closeNewTicketDialog"
      ></newTicketDialog> -->
      </v-row>
    </v-container>
    <contactDetailsDialog
      v-if="contactDetailsDialog"
      :isActive="contactDetailsDialog"
      :userData="dataUserActiveChat"
      @dialog:close="closeContactDetailsDialog"
    ></contactDetailsDialog>

    <transferChatDialog
      v-if="transferChatDialog"
      :transferType="transferType"
      :isActive="transferChatDialog"
      :currentAgentId="userId"
      @dialog:close="closeAgentDialog"
    ></transferChatDialog>

    <typification-form
      v-if="formDialog"
      :dialog="formDialog"
      @close:dialog="closeTypificationDialog"
      :temporaryTableId="temporaryTable_id"
      :isEditMode="false"
      :queueNumber="queueNumberSelected"
      :requestOptions="options"
    />
    <quick-message-dialog
      v-if="isOpenQuickMsgDialog"
      :isActive="isOpenQuickMsgDialog"
      :agent="userName"
      @dialog:close="toggleQuickMsgDialog"
    ></quick-message-dialog>

    <!-- DIALOGO GRABAR AUDIO -->
    <v-dialog
      persistent
      max-width="400"
      transition="dialog-bottom-transition"
      v-if="audioRecorderDialog"
      v-model="audioRecorderDialog"
    >
      <v-card>
        <v-card-text class="pt-8">
          <v-container>
            <v-row justify="center">
              <v-col cols="12">
                <div class="text-h2 text-center">{{ formattedTime }}</div>
              </v-col>

              <v-col cols="12" class="text-center">
                <span class="mx-auto">
                  <v-btn fab large class="mx-1" @click="startRecording" :disabled="isRecording || audioUrl != null">
                    <v-icon>mdi-microphone</v-icon>
                  </v-btn>
                  <v-btn
                    fab
                    class="mx-1"
                    @click="stopRecording"
                    :disabled="!isRecording"
                    :color="isRecording ? 'error' : ''"
                  >
                    <v-icon>mdi-stop</v-icon>
                  </v-btn>
                </span>
              </v-col>

              <v-col cols="12" class="text-center" v-if="audioUrl">
                <audio controls @loadedmetadata="updateDuration">
                  <source :src="audioUrl" type="audio/webm" />
                  Tu navegador no soporta audio HTML5.
                </audio>

                <v-btn class="mt-1" text small @click="clearAudio" :disabled="isRecording || !audioUrl"
                  >Limpiar Audio</v-btn
                >
              </v-col>
            </v-row>
          </v-container>
          <!-- <v-btn @click="pauseRecording" :disabled="!isRecording || isPaused"
            >Pausar Grabación</v-btn
          > -->
          <!-- <v-btn @click="stopRecording" :disabled="!isRecording && !isPaused"
            >Detener Grabación</v-btn
          > -->
        </v-card-text>

        <v-card-actions class="justify-end">
          <v-btn text @click="audioRecorderDialog = false">Cerrar</v-btn>
          <v-spacer></v-spacer>
          <v-btn text @click="sendAudio" :disabled="!audioUrl">Enviar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- DIALOGO VER FOTO -->
    <!-- ALTERNATIVO SOLUCION RAPIDA -->
    <v-dialog v-model="imageDialog" max-width="800">
      <v-card>
        <v-card-title>
          <v-toolbar dense flat color="transparent">
            <v-btn small icon @click="imageDialog = false">
              <v-icon>mdi-close</v-icon>
            </v-btn>
            <v-toolbar-title>Vista previa</v-toolbar-title>
            <v-spacer></v-spacer>
            <a :href="urlPhotoPreview" :download="getFileName(urlPhotoPreview)">
              <v-btn small icon>
                <v-icon>mdi-download</v-icon>
              </v-btn>
            </a>
          </v-toolbar>
        </v-card-title>
        <!-- <v-toolbar dense flat>
          <v-spacer></v-spacer>
          <v-btn icon @click="imageDialog = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-toolbar> -->

        <img :src="selectedImage" style="max-height: 80vh; max-width: 100%; object-fit: contain;" />
      </v-card>
    </v-dialog>
    <!-- FIN ALTERNATIVO SOLUCION RAPIDA -->
    <v-dialog
      width="800"
      v-if="isActivePhotoPreview"
      v-model="isActivePhotoPreview"
      transition="dialog-bottom-transition"
    >
      <!-- <template v-slot:activator="{ props }">
        <v-btn v-bind="props" text="Open Dialog"> </v-btn>
      </template>

      <template v-slot:default="{ isActivePhotoPreview }"> -->
      <v-card>
        <v-card-title>
          <v-toolbar dense flat color="transparent">
            <v-btn small icon @click="isActivePhotoPreview = false">
              <v-icon>mdi-close</v-icon>
            </v-btn>
            <v-toolbar-title>Vista previa</v-toolbar-title>
            <v-spacer></v-spacer>
            <a :href="urlPhotoPreview" :download="getFileName(urlPhotoPreview)">
              <v-btn small icon>
                <v-icon>mdi-download</v-icon>
              </v-btn>
            </a>
          </v-toolbar>
        </v-card-title>

        <v-card-text>
          {{ urlPhotoPreview }}
          <v-carousel hide-delimiters show-arrows-on-hover :value="currentPhoto">
            <!-- :src="item.mediaUrl" -->
            <v-carousel-item v-for="item in chatGalleryList" :key="item.id + 'preview'" cover>
              <v-img :src="item.mediaUrl"></v-img>
            </v-carousel-item>
          </v-carousel>
        </v-card-text>
      </v-card>
      <!-- </template> -->
    </v-dialog>

    <!-- DIALOGO VER MENSAJES PREDEFINIDOS -->
    <v-dialog
      width="700"
      v-if="isActivePreMessages"
      v-model="isActivePreMessages"
      transition="dialog-bottom-transition"
    >
      <!-- <template v-slot:activator="{ props }">
        <v-btn v-bind="props" text="Open Dialog"> </v-btn>
      </template>

      <template v-slot:default="{ isActivePhotoPreview }"> -->
      <v-card>
        <v-card-title>
          <v-toolbar dense flat color="transparent">
            <v-toolbar-title>Mensajes predefinidos</v-toolbar-title>
            <v-spacer></v-spacer>
          </v-toolbar>
          <v-btn small icon @click="isActivePreMessages = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>
        <v-divider></v-divider>

        <vuescroll
          :ops="{
            bar: { background: '#bacfcec0', keepShow: true },
          }"
        >
          <v-card-text>
            <v-list>
              <v-list-item v-for="item in preMessagesList" :key="item.id" @click="copyPreMessage(item.message)">
                <v-list-item-content>
                  <p class="mb-0 pb-0">
                    {{ item.title }}
                  </p>
                </v-list-item-content>
              </v-list-item>
            </v-list>
          </v-card-text>
        </vuescroll>
      </v-card>
      <!-- </template> -->
    </v-dialog>

    <search-dialog
      module="chat"
      :open="isOpenSearch"
      :phoneNumber="dataUserActiveChat.whatsapp"
      @dialog:submit="handleSendSearch"
      @dialog:close="closeSearchDialog"
    ></search-dialog>
  </section>
</template>

<script>
// import axios from "axios";
import moment from "moment";
import vuescroll from "vuescroll";
import { mapState } from "vuex";

import { PbxHttpClient } from "@/services/httpclient";
// import newTicketDialog from "@/components/chats/newTicketDialog.vue";
import transferChatDialog from "@/components/chats/transferChatDialog.vue";
import contactDetailsDialog from "@/components/chats/contactDetailsDialog.vue";
import TypificationForm from "@/views/app/agents/Typification/TypificationForm.vue";
import QuickMessageDialog from "@/components/chats/QuickMessageDialog.vue";
import SearchDialog from "@/components/CDR/Whatsapp/SearchDialog.vue";

// BUBBLE MESSAGE COMPONENTS
import BubbleText from "./messageTypeBubble/BubbleText.vue";
import BubbleFile from "./messageTypeBubble/BubbleFile.vue";
import BubbleVcard from "./messageTypeBubble/BubbleVcard.vue";

import {
  resetUnreadMessages,
  generateListedMessage,
  generateQueueListedChat,
  generateUpdateQueueChat,
  generateUpdateListChat,
} from "@/components/chats/utils";
import PendingChatsSection from "@/components/chats/PendingChatsSection.vue";
import ActiveChatsSection from "@/components/chats/ActiveChatsSection.vue";

const workerOptions = {
  OggOpusEncoderWasmPath: "https://cdn.jsdelivr.net/npm/opus-media-recorder@latest/OggOpusEncoder.wasm",
  WebMOpusEncoderWasmPath: "https://cdn.jsdelivr.net/npm/opus-media-recorder@latest/WebMOpusEncoder.wasm",
};

export default {
  components: {
    vuescroll,
    transferChatDialog,
    contactDetailsDialog,
    TypificationForm,
    QuickMessageDialog,
    PendingChatsSection,
    ActiveChatsSection,
    SearchDialog,
    // newTicketDialog,
    // BUBBLE MESSAGE COMPONENTS
    BubbleText,
    BubbleFile,
    BubbleVcard,
  },

  data: () => ({
    // Contador de pendientes:
    queueCount: 0,
    queueCountInterval: null,
    // Filtro de chats: 0 = Todos, 1 = Leidos, 2 = Sin leer
    readFilter: 0,
    search: "",
    searchTimeout: null,
    //////
    imageDialog: false,
    selectedImage: null,
    //////
    activePage: 1,
    queuePage: 1,
    itemPerPage: 100,
    isLoadingMoreActive: false,
    isLoadingMoreQueue: false,
    //////
    tabChats: 0,
    audioStream: null, // Add this property
    imageSrc: "",
    isReplyingMessage: false,
    isPaused: false,
    isOpenSearch: false,
    audioChunks: [],
    mediaRecorder: null,
    audioUrl: null,
    duration: null,
    startTime: null,
    durationInterval: null,
    formattedTime: "00:00",
    firmaObligatoria: false,
    //
    page: 1,
    last_page: 50,
    allMessageShowed: false,
    autoGrow: false,
    urlPhotoPreview: "",
    isActivePhotoPreview: false,
    componentKey: 0,
    isLoading: true,
    isLoadingChat: false,
    isSendingMessage: false,
    transferChatDialog: false,
    contactDetailsDialog: false,
    audioRecorderDialog: false,
    formDialog: false,
    historyIsActive: false,
    openChatMobile: undefined,
    transferType: "",
    userDataDetails: {},
    // newTicketDialog: false,
    queueItemsFilter: [],
    queueIdFilter: null,
    selected: [2],
    activeChatsPage: 1,
    queueChatsPage: 1,
    selectedActiveChat: null,
    activeChatsList: [],
    queueChatsList: [],
    totalActiveChats: 0,
    totalQueueChats: 0,
    dataUserActiveChat: {
      id: null,
      contactId: null,
      name: "",
      avatar: "",
      whatsapp: "",
      phone1: "",
      typeTicketId: "",
      TicketId: "",
      whatsappId: "",
    },
    messagesList: [],
    files: [
      { text: "Landing_page.zip", icon: " mdi-cloud-upload" },
      { text: "Requirements.pdf", icon: " mdi-cloud-upload" },
      { text: "Uwagi.docx", icon: " mdi-cloud-upload" },
    ],
    panel: [2],

    password: "Password",
    show: false,
    fileExist: false,
    fileSelected: null,
    message: "",
    marker: true,
    iconIndex: 0,
    temporaryTable_id: null,
    isOpenQuickMsgDialog: false,
    // actualDateItemChat: null,
    // NextDateItemChat: null
    previousDates: {},
    isActivePreMessages: false,
    preMessagesList: [],
    totalPreSmsItems: null,
    chatGalleryList: [],
    currentPhoto: null,
    replyMessageContent: null,
    selectedChat: null,
    refreshInterval: null,
  }),

  computed: {
    refreshChats() {
      return this.$store.state.refreshChats;
    },

    isMobile() {
      return this.$vuetify.breakpoint.mobile;
    },

    newMessage() {
      return this.$store.getters["chats/GET_NEW_MESSAGE"];
    },

    clientId() {
      return this.$store.getters["passport/GET_CLIENT_ID"];
    },

    ...mapState({
      // Breaks: state => state.breaks.allBreaks,
      userId: (state) => state.passport.user.id,
      userName: (state) => state.passport.user.name,
      canSign: (state) => (state.passport.user.client.has_signature === 0 ? false : true),
    }),
  },

  watch: {
    tabChats(val) {
      const tabName = val === 0 ? "active" : "pending";

      let newQuery = { ...this.$route.query, tab: tabName };

      if (val === 1) {
        delete newQuery.chatId;
      }
      this.$router
        .push({
          query: newQuery,
        })
        .catch(() => {});
      this.onSearch();
    },

    newMessage(val) {
      debugger;
      if (val) this.handleNewMessage();
    },

    isReplyingMessage(newVal) {
      this.updateLayoutHeight(newVal);
    },

    refreshChats() {
      if (this.selectedChat) return;
      this.refreshComponent(); // Call the method when the state changes
    },

    "$route.query": {
      immediate: true,
      handler(query) {
        if (query.tab && ["active", "pending"].includes(query.tab)) {
          this.tabChats = query.tab === "pending" ? 1 : 0;
        }
      },
    },

    // search(value) {
    //   // Evitar búsquedas al enfocar o cuando es null
    //   if (value === null) return;

    //   // Si no hay texto, no buscar automáticamente
    //   if (value.trim() === "") return;

    //   if (this.searchTimeout) {
    //     clearTimeout(this.searchTimeout);
    //   }

    //   this.searchTimeout = setTimeout(() => {
    //     this.onSearch();
    //   }, 1500);
    // },

    // messagesList() {
    //   if (this.$refs.messageListVs) {
    //     this.$refs.messageListVs.scrollTo({ x: 0, y: "100%" });
    //   }
    // },
  },

  filters: {
    getHour12Format(date) {
      const hour = moment(date).format("LT");
      return hour;
    },
  },

  created() {
    this.getActiveChats(false);
    this.getQueueChats();
    this.getQueueItemFilters();
    this.getPreMessage();
    if (this.canSign) this.firmaObligatoria = true;
  },

  mounted() {
    // this.refreshInterval = setInterval(() => {
    //   if (this.selectedChat) this.chatPreview(this.selectedChat, true, true);
    //   this.getQueueChats(false, false);
    // }, 10000);

    // Primera carga inmediata
    this.getQueueCount();

    // Ejecutar cada 20 segundos
    this.queueCountInterval = setInterval(() => {
      this.getQueueCount();
    }, 20000);

    // To ensure the height is correct when starting the component
    // this.updateLayoutHeight(this.isReplyingMessage);
    // this.$root.$on('refresh-chat-panel', this.refreshComponent);
  },

  beforeDestroy() {
    clearInterval(this.refreshInterval);
    // this.$root.$off('refresh-chat-panel', this.refreshComponent);

    if (this.queueCountInterval) {
      clearInterval(this.queueCountInterval);
    }
  },

  methods: {
    getFormattedPhone(user) {
      if (!user) return "";

      const parts = [];

      // 1. Validar phone2 (nombre de usuario)
      if (user.phone2) {
        parts.push(user.phone2);
      }

      // 2. Validar phone1 (solo si existe y NO empieza por letras)
      if (user.phone1 && !/^[a-zA-Z]/.test(user.phone1)) {
        parts.push(user.phone1);
      }

      // Si no hay ningún teléfono válido, no muestra paréntesis
      if (parts.length === 0) return "";

      return ` (${parts.join(" - ")})`;
    },

    /**
     * Consulta el total de chats en cola y actualiza la variable reactiva.
     */
    async getQueueCount() {
      try {
        const url = `/whatsapps/chat/index_queue_count`;

        const { data } = await PbxHttpClient.get(url);

        // Ajusta según la estructura real del response
        this.queueCount = data.cantidad;
      } catch (error) {
        console.error("Error al obtener queue count:", error);
      }
    },

    async onSearch() {
      if (this.tabChats === 0) {
        this.activePage = 1;
        await this.getActiveChats(false);
      } else if (this.tabChats === 1) {
        this.queuePage = 1;
        await this.getQueueChats(false);
      }
    },

    onClearSearch() {
      this.search = "";
      // this.onSearch();
    },

    async onFilterChange() {
      if (this.tabChats !== 0) return;

      this.activePage = 1;
      await this.getActiveChats(false);
    },

    openImageModal(url) {
      this.selectedImage = url;
      this.imageDialog = true;
    },

    getFileName(url) {
      return url.substring(url.lastIndexOf("/") + 1);
    },

    // updateLayoutHeight(isReplying) {
    //   if (this.$refs.chatPreviewRef) {
    //     const chatPreviewRef = this.$refs.chatPreviewRef;
    //     // Remove both classes for safety before adding the correct one
    //     chatPreviewRef.classList.remove('layout-default', 'layout-replying');
    //     // Add the corresponding class according to the isReplyingMessage state
    //     if (isReplying) {
    //       chatPreviewRef.classList.add('layout-replying');
    //     } else {
    //       chatPreviewRef.classList.add('layout-default');
    //     }
    //   }
    // },

    replyMessage(message) {
      this.isReplyingMessage = true;
      this.replyMessageContent = message;
    },

    onCloseReply(value) {
      if (!value) {
        this.isReplyingMessage = false;
        this.replyMessageContent = null;
      }
    },

    copyPreMessage(item) {
      this.message = this.message + " " + item;
      this.isActivePreMessages = false;
    },

    onEnterKey(event) {
      // Check if Alt or Shift are not pressed, to avoid interfering with line insertion
      if (!event.altKey && !event.shiftKey) {
        this.sendMessage(); // Send the message if only Enter is pressed
      }
    },

    insertNewLine(event) {
      // Insert a new line when Alt + Enter or Shift + Enter is pressed
      this.message += "\n";
      event.preventDefault(); // Prevent default behavior
    },

    async getPreMessage() {
      this.isLoading = true;

      // const { page, itemsPerPage } = this.options;

      await PbxHttpClient.get(`/whatsapps/preset-messages`, {
        params: { page: 1, itemPerPage: 100 },
      })
        .then((res) => {
          this.preMessagesList = res.data.data;
          this.totalPreSmsItems = res.data.total;
        })
        .catch(() => {
          // console.error(error);
          this.$snotify.error("Hubo un error en la consulta.", "Error");
        })
        .finally(() => {
          this.isLoading = false;
        });
    },

    handlePaste(event) {
      const clipboardData = event.clipboardData || window.clipboardData;
      const items = clipboardData.items;

      for (let i = 0; i < items.length; i++) {
        if (items[i].type.indexOf("image") !== -1) {
          const blob = items[i].getAsFile();
          this.fileSelected = blob; // Simulate file selection
          this.fileExist = true; // Show file input
          break; // Exit loop after first image is found
        }
      }
    },

    async deleteMessage(id) {
      try {
        const confirmRequest = await this.$swalconfirm("Eliminar mensaje", `Ésta acción no es reversible.`);
        if (confirmRequest.isConfirmed) {
          const res = await PbxHttpClient.post(`/whatsapps/chat/delete_message`, { messageid: id });

          if (res.data.success) {
            const indice = this.messagesList.findIndex((subarreglo) => subarreglo[0].id === id);

            if (indice !== -1) {
              this.messagesList.splice(indice, 1);
            }

            this.$snotify.success("Mensaje eliminado", "¡Hecho!");
          }
        }
      } catch (error) {
        this.$snotify.error("No se pudo eliminar el mensaje.", "¡Error!");
        // console.error(error);
      }
    },

    async getList(search = null) {
      this.searchData = search ?? this.searchData;

      this.$store.commit("layout/SET_OVERLAY", { value: true, title: "Cargando" });

      const page = 1;
      const itemPerPage = 100;

      try {
        const { data } = await PbxHttpClient.post(`/whatsapps/chat/admin/index_admin`, this.searchData, {
          params: { page, itemPerPage },
        });

        this.activeChatsList = data.data;
        this.totalItems = data.total;
      } catch (err) {
        console.error("Hubo un error en la consulta:", err);
        this.$snotify.error("Hubo un error en la consulta.", "Error");
      } finally {
        this.historyIsActive = true;
        this.isLoading = false;
        this.$store.commit("layout/SET_OVERLAY", { value: false, title: "" });
      }
    },

    handleSendSearch(search) {
      this.getList(search);
      this.closeSearchDialog();
    },

    closeSearchDialog() {
      this.isOpenSearch = false;
    },

    shouldDisplayChip(date, identifier) {
      console.log("Checking chip for:", date, "in group:", identifier);
      const previousDate = this.previousDates[identifier];
      console.log("Previous date in group", identifier, ":", previousDate);
      if (!previousDate || previousDate !== date) {
        this.$set(this.previousDates, identifier, date);
        console.log("Chip displayed for:", date);
        return true;
      } else {
        console.log("Chip not displayed for:", date);
        return false;
      }
    },

    updateDuration() {
      const currentTime = Math.floor((Date.now() - this.startTime) / 1000); // Calculate elapsed time in seconds
      const minutes = Math.floor(currentTime / 60);
      const seconds = currentTime % 60;
      this.formattedTime = `${minutes.toString().padStart(2, "0")}:${seconds.toString().padStart(2, "0")}`;
    },

    clearAudio() {
      this.audioChunks = [];
      this.audioUrl = null;
      this.duration = null;
      this.formattedTime = "00:00";
    },

    startRecording() {
      this.startTime = Date.now();
      this.isRecording = true;
      this.durationInterval = setInterval(this.updateDuration, 1000);

      navigator.mediaDevices
        .getUserMedia({ audio: true })
        .then((stream) => {
          this.audioStream = stream; // Save the stream
          this.mediaRecorder = new MediaRecorder(
            stream,
            {
              mimeType: "audio/ogg;codecs=opus",
            },
            workerOptions,
          );
          this.mediaRecorder.addEventListener("dataavailable", (event) => {
            if (event.data.size > 0) {
              this.audioChunks.push(event.data);
            }
          });
          this.mediaRecorder.addEventListener("stop", () => {
            const audioBlob = new Blob(this.audioChunks, {
              type: "audio/ogg;codecs=opus",
            });
            this.audioUrl = URL.createObjectURL(audioBlob);
          });
          this.mediaRecorder.start();
          this.isRecording = true;
        })
        .catch((error) => {
          console.error("Error al acceder al micrófono:", error);
        });
    },

    stopRecording() {
      clearInterval(this.durationInterval);
      if (this.mediaRecorder && (this.mediaRecorder.state === "recording" || this.mediaRecorder.state === "paused")) {
        this.mediaRecorder.stop();
        this.isRecording = false;
        this.isPaused = false;
        this.audioChunks = [];
      }

      if (this.audioStream) {
        // Stop the microphone stream
        this.audioStream.getTracks().forEach((track) => track.stop());
        this.audioStream = null; // Release the stream
      }
    },

    pauseRecording() {
      if (this.mediaRecorder && this.mediaRecorder.state === "recording") {
        this.mediaRecorder.pause();
        this.isPaused = true;
      }
    },

    async getChatGallery() {
      try {
        this.isLoadingGallery = true;

        const res = await PbxHttpClient.get(`/whatsapps/chat/index_images?ticket_id=${this.dataUserActiveChat.id}`);

        if (res.status === 500) {
          this.chatGalleryList = res.data;
          this.chatGalleryList = this.chatGalleryList.reverse();
        }
      } catch (error) {
        this.$snotify.error("No se pudo obtener listado de fotos.", "¡Error!");
        this.isLoadingGallery = false;
        // console.error(error);
      }
    },

    photoPreview(photo_id) {
      if (this.chatGalleryList.length === 0) {
        this.getChatGallery();
      }
      this.currentPhoto = photo_id;
      const itemIndex = this.chatGalleryList.findIndex((item) => item.id === photo_id);
      if (itemIndex !== -1) {
        this.currentPhoto = itemIndex;
      }
      this.urlPhotoPreview = this.chatGalleryList[itemIndex].mediaUrl;

      this.isActivePhotoPreview = true;
    },

    closePhotoPreview() {
      this.urlPhotoPreview = "";
      this.isActivePhotoPreview = false;
    },

    forceReRender() {
      this.autoGrow = !this.autoGrow;
    },

    refreshComponent() {
      this.componentKey += 1;
      this.getActiveChats(false, false);
    },

    dateFormat(date) {
      const dateFormatted = date
        .toString()
        .slice(0, 10)
        .split("-")
        .reverse()
        .join("/");
      return dateFormatted;
    },

    clearMessage() {
      this.message = "";
      this.fileExist = false;
      this.fileSelected = null;
    },

    resetIcon() {
      this.iconIndex = 0;
    },

    filteredList() {
      this.activeChatsList = this.activeChatsList.filter((item) => item.includes(this.search));
    },

    openChatPanelOnMobile() {
      const elemento1 = document.getElementById("chatListPanel");
      elemento1.classList.add("d-none");

      const elemento2 = document.getElementById("chatViewPanel");
      elemento2.classList.remove("d-none");
    },

    closeChatPanelOnMobile() {
      const elemento1 = document.getElementById("chatViewPanel");
      elemento1.classList.add("d-none");

      const elemento2 = document.getElementById("chatListPanel");
      elemento2.classList.remove("d-none");
    },

    openTypificationDialog() {
      this.formDialog = true;
    },
    closeTypificationDialog() {
      this.formDialog = false;
    },

    openPreMessagesDialog() {
      this.isActivePreMessages = true;
    },
    openContactDetailsDialog() {
      this.contactDetailsDialog = true;
    },
    closeContactDetailsDialog() {
      this.contactDetailsDialog = false;
    },

    OpenAgentDialog(TransferTo) {
      this.transferType = TransferTo;
      // if (TransferTo === "user") this.transferChatDialog = true;
      // else if (TransferTo === "queue") this.handleChat("queue");
      this.transferChatDialog = true;
    },
    closeAgentDialog(value) {
      if (value) this.handleChat("transfer", value);
      this.transferChatDialog = false;
    },

    // async TransferToQueue() {
    //   try {
    //     await PbxHttpClient.put(
    //       `/whatsapps/update_ticket/${this.dataUserActiveChat.id}`
    //     );

    //     this.dataUserActiveChat = {
    //       id: null,
    //       name: "",
    //       avatar: "",
    //       whatsapp: "",
    //       phone1: "",
    //     };

    //     this.getActiveChats();
    //     this.messagesList = [];
    //   } catch (error) {
    //     console.error(error);
    //     this.$snotify.error("No se pudo transferir el chat.", "¡Error!");
    //   }
    // },

    gotToContacts() {
      this.$router.push({ name: "Contacts" });
    },

    // openNewTicketDialog() {
    //   this.newTicketDialog = true;
    // },
    // closeNewTicketDialog(value) {
    //   if (value === true) this.getActiveChats();
    //   this.newTicketDialog = false;
    // },

    filterChats(value) {
      this.queueIdFilter = value;
      this.getActiveChats(this.queueIdFilter);
    },

    closeHistoryPanel() {
      this.historyIsActive = false;
      this.getActiveChats(false);
      this.messagesList = [];
      this.dataUserActiveChat = {
        id: null,
        contactId: null,
        name: "",
        avatar: "",
        whatsapp: "",
        phone1: "",
        typeTicketId: "",
        whatsappId: "",
      };
    },

    async getQueueItemFilters() {
      try {
        const { data } = await PbxHttpClient.get("/clients/index_whatsapp");
        this.queueItemsFilter = [{ id: null, name: "Todos" }, ...data.data];
        this.queueIdFilter = this.queueItemsFilter[0].id;
      } catch (error) {
        console.log("error getting index whatsapp", error);
        this.$snotify.error("Hubo un error en la consulta.", "Error");
      }
    },

    loadMoreActiveChats() {
      if (this.activeChatsList.length >= this.totalActiveChats) return;
      this.activePage++;
      this.getActiveChats(true);
    },

    loadMoreQueueChats() {
      if (this.queueChatsList.length >= this.totalQueueChats) return;
      this.queuePage++;
      this.getQueueChats(true);
    },

    async enviarMensajeSolicitudArchivo(ticketId) {
      try {
        await PbxHttpClient.post(`/whatsapps/chat/upload_pdf`, { ticket_id: ticketId });
        this.$snotify.success("Solicitud de archivo enviada con éxito.", "¡Hecho!");
      } catch (error) {
        console.error("Error al enviar la solicitud de archivo:", error);
      }
    },

    async getActiveChats(loadMore = false, showLoaders = true) {
      if (this.isLoadingMoreActive) return;

      this.isLoading = showLoaders;
      this.isLoadingMoreActive = showLoaders;

      const url = `/whatsapps/chat/index_activo?queue_id=${this.queueIdFilter}`;
      const res = await PbxHttpClient.get(url, {
        params: {
          itemPerPage: this.itemPerPage,
          page: this.activePage,
          search: this.search || null,
          readFilter: this.readFilter,
        },
      });

      const activeChats = res.data.data.filter((chat) => !(chat.last_message === null && chat.typeTicketId === 4));

      this.activeChatsList = loadMore ? [...this.activeChatsList, ...activeChats] : activeChats;

      this.totalActiveChats = res.data.total;

      this.isLoading = false;
      this.isLoadingMoreActive = false;
    },

    async getQueueChats(loadMore = false, showLoaders = true) {
      if (this.isLoadingMoreQueue) return;

      this.isLoading = showLoaders;
      this.isLoadingMoreQueue = true;

      const url = `/whatsapps/chat/index_queue?queue_id=${this.queueIdFilter}`;
      const res = await PbxHttpClient.get(url, {
        params: {
          itemPerPage: this.itemPerPage,
          page: this.queuePage,
          search: this.search || null,
        },
      });

      const sorted = [...res.data.data].sort((a, b) => new Date(a.created_at) - new Date(b.created_at));

      this.queueChatsList = loadMore ? [...this.queueChatsList, ...sorted] : sorted;

      this.queueChatsList = this.queueChatsList.sort((a, b) => {
        const dateA = new Date(a.updated_at).getTime();
        const dateB = new Date(b.updated_at).getTime();

        return dateB - dateA;
      });

      this.totalQueueChats = res.data.total;

      this.isLoading = false;
      this.isLoadingMoreQueue = false;
    },

    /**
     * Accepts a chat, updates its status to "open" and refreshes the active chats list.
     * Then opens the preview of the selected chat.
     *
     * @param {Object} item - Chat object to accept.
     * @param {number|string} item.id - Ticket/chat ID.
     */
    async aceptChat(item) {
      this.$store.commit("layout/SET_OVERLAY", {
        value: true,
        title: "Aceptando...",
      });

      try {
        // Build current date in format required by backend
        const date = moment().format("YYYY-MM-DD HH:mm:ss");

        // Payload that updates the ticket status
        const payload = {
          status: "open",
          userId: this.userId,
          unreadMessages: 0,
          toOPerDate: date,
        };

        // Make the request to open the ticket
        const res = await PbxHttpClient.put(`/whatsapps/open_ticket/${item.id}`, payload);

        // Refresh the active chats list to show the new status
        this.search = "";

        // Remove accepted chat from queue list
        this.queueChatsList = this.queueChatsList.filter((chat) => chat.id !== item.id);
        await this.getActiveChats();
        // await this.getQueueChats();

        this.tabChats = 0;
        this.totalQueueChats = this.totalQueueChats - 1;

        // Set the accepted chat as selected
        this.selectedActiveChat = item.id;

        // Show the preview of the accepted chat with possible type change
        this.chatPreview({ ...item, typeTicketId: res.data.typeTicketId }, false);

        // Notify the user that it was accepted successfully
        this.$snotify.success("Ticket aceptado con éxito.", "¡Hecho!");
      } catch (err) {
        // In case of error, show notification to user
        this.$snotify.error("No se pudo aceptar el chat.", "¡Error!");
      } finally {
        this.$store.commit("layout/SET_OVERLAY", { value: false, title: "" });
      }
    },

    async handleChat(status, id) {
      this.$store.commit("layout/SET_OVERLAY", {
        value: true,
        title: "Resolviendo",
      });
      if (["closed", "closedTip", "transfer"].includes(status)) {
        clearInterval(this.refreshInterval);
      }
      try {
        const date = moment().format("YYYY-MM-DD HH:mm:ss");

        let payload = {
          status: status === "transfer" ? "pending" : status,
          unreadMessages: 0,
          ...((status === "closed" || status === "closedTip") && {
            closedTime: date,
            typing: status === "closedTip",
          }),
          ...(status === "pending" && { userId: null }),
          ...(status === "transfer" && this.transferType === "user" && { userId: id, toOPerDate: date }),
          ...(status === "transfer" && this.transferType === "queue" && { queueId: id }),
          ...(status === "queue" && { toOPerDate: date, userId: null }),
        };
        if (status === "closedTip") payload.status = "closed";

        const { data } = await PbxHttpClient.put(`/whatsapps/update_ticket/${this.dataUserActiveChat.id}`, payload);

        this.dataUserActiveChat = {
          id: null,
          contactId: null,
          name: "",
          avatar: "",
          whatsapp: "",
          phone1: "",
          typeTicketId: "",
          whatsappId: "",
        };

        await this.getActiveChats();
        await this.getQueueChats();

        this.messagesList = [];

        const successMessages = {
          pending: "Ticket devuelto a la cola.",
          closed: "Ticket cerrado con éxito.",
          closedTip: "Ticket cerrado con éxito.",
        };

        this.$snotify.success(successMessages[status], "¡Hecho!");

        if (status === "closedTip") {
          this.temporaryTable_id = data.temporaryTable_id;
          this.openTypificationDialog();
        }
      } catch (err) {
        this.$snotify.error("No se pudo cerrar el chat.", "¡Error!");
      } finally {
        this.$store.commit("layout/SET_OVERLAY", { value: false, title: "" });
      }
    },

    // Query ticket history
    async userHistory() {
      try {
        // this.isLoading = true;
        this.isLoadingChat = true;

        // if (this.historyIsActive && this.page < this.last_page) {
        //   this.page = this.page + 1;
        // }

        if (this.page < this.last_page) {
          const res = await PbxHttpClient.get(`/whatsapps/chat/tickets_history/${this.dataUserActiveChat.contactId}`, {
            params: {
              page: this.page,
              itemPerPage: 100,
              whatsappId: this.dataUserActiveChat.whatsappId,
            },
          });
          this.last_page = res.last_page;

          if (this.historyIsActive === false) {
            // this.messagesList = data;

            this.historyIsActive = true;
          }

          this.page === this.last_page ? (this.allMessageShowed = true) : "";

          // const messages = res.data;
          // const reversedKeys = Object.keys(messages).reverse();

          // reversedKeys.forEach((key) => {
          //   this.messagesList.push(messages[key]);
          // });

          this.messagesList = res.data;

          // else {
          //   // this.messagesList = this.messagesList.concat(data.data);
          //   const messages = res.data;
          //   const reversedKeys = Object.keys(messages).reverse();

          //   reversedKeys.forEach((key) => {
          //     this.messagesList.push(messages[key]);
          //   });
          // }
        }

        // this.getActiveChats();

        this.isLoadingChat = false;
      } catch (err) {
        this.$snotify.error("No se pudo consultar historial.", "¡Error!");
      }

      // this.isLoading = false;
    },

    async sendMessage() {
      this.isSendingMessage = true;
      this.$store.commit("layout/SET_OVERLAY", {
        value: true,
        title: "Enviando",
      });

      try {
        if (this.canSign || this.firmaObligatoria) {
          this.message = `*${this.userName}*:\n${this.message}`;
        }

        // Save reference to the message before clearing it
        const messageToSend = this.message;

        // Create temporary message with sending status
        const tempMessage = {
          id: `temp_${Date.now()}`,
          body: messageToSend,
          fromMe: 1,
          mediaType: "chat",
          created_at: new Date().toISOString(),
          ack: 0, // Sending status (0 = clock, 1 = one check, 2 = two checks, 3 = read)
          isTemp: true, // Mark to identify temporary messages
        };

        // Add temporary message to the list immediately
        this.messagesList.push([tempMessage]);

        // Scroll to the end
        setTimeout(() => {
          if (this.$refs.messageListVs) {
            this.$refs.messageListVs.scrollTo({ x: 0, y: "100%" });
          }
        }, 500); // Wait to ensure DOM updates

        const payload = {
          ticket_id: this.dataUserActiveChat.id,
          message: messageToSend,
        };

        if (this.isReplyingMessage) payload.serialized = this.replyMessageContent.serialized;

        const urlMap = {
          1: "/whatsapps/send_message",
          2: "/web/send_message",
          3: "/telegram/SendMessageAgent",
          4: "/Ws_gupshup/send_message",
          5: "/meta/send_message",
          6: "/meta/send_message",
          7: "/meta/send_message",
          8: "/chat/index_chat_email",
        };

        const url = urlMap[this.dataUserActiveChat.typeTicketId] || urlMap[1];

        // Send message and update status
        PbxHttpClient.post(url, payload)
          .then((res) => {
            // Replace temporary message with real one from server
            const messageIndex = this.messagesList.findIndex((group) =>
              group.some((msg) => msg.isTemp && msg.body === messageToSend),
            );

            console.log("Index found:", messageIndex);

            if (messageIndex !== -1) {
              // Replace the temporary group with the real message from server
              this.messagesList.splice(messageIndex, 1, [generateListedMessage(res.data)]);
              console.log("Temporary message replaced successfully");
            } else {
              console.log("Temporary message not found for replacement");
            }
          })
          .catch(() => {
            // In case of error, update temporary message with error status
            const messageIndex = this.messagesList.findIndex((group) =>
              group.some((msg) => msg.isTemp && msg.body === messageToSend),
            );

            if (messageIndex !== -1) {
              const tempMsg = this.messagesList[messageIndex][0];
              tempMsg.ack = -1; // Error status
              tempMsg.isTemp = false;
            }

            this.$snotify.error("No se pudo enviar el mensaje.");
          });

        // Continue flow without waiting
        this.resetIcon();
        this.clearMessage();
        this.onCloseReply();
      } finally {
        this.isSendingMessage = false;
        this.$store.commit("layout/SET_OVERLAY", { value: false, title: "" });
      }
    },

    verifyFile() {
      if (this.fileSelected) {
        this.fileExist = true;
      } else {
        this.fileExist = false;
      }
    },

    async sendImage() {
      this.$store.commit("layout/SET_OVERLAY", {
        value: true,
        title: "Enviando",
      });

      this.isSendingMessage = true;

      try {
        const fileType = this.fileSelected.type;
        const isImage = fileType.startsWith("image/");

        // Save reference to the filename before clearing it
        const fileNameToSend = this.fileSelected.name;

        // Create temporary message with sending status
        const tempMessage = {
          id: `temp_${Date.now()}`,
          body: fileNameToSend,
          fromMe: 1,
          mediaType: isImage ? "image" : "file",
          mediaUrl: URL.createObjectURL(this.fileSelected),
          created_at: new Date().toISOString(),
          ack: 0, // Sending status (0 = clock)
          isTemp: true, // Mark to identify temporary messages
        };

        // Add temporary message to the list immediately
        this.messagesList.push([tempMessage]);

        // // Scroll to the end
        // this.$nextTick(() => {
        //   if (this.$refs.messageListVs) {
        //     this.$refs.messageListVs.scrollTo({ x: 0, y: "100%" });
        //   }
        // });

        const payload = new FormData();
        payload.append("file", this.fileSelected);
        payload.append("ticket_id", this.dataUserActiveChat.id);
        payload.append("message", fileNameToSend);

        if (isImage) {
          payload.append("type", "image");
        } else {
          payload.append("mediaType", "file");
          payload.append("type", "file");
        }

        const urlMap = {
          1: "/whatsapps/send_media",
          2: "/web/send_media",
          3: "/telegram/send-image-agent",
          4: "/Ws_gupshup/send_image_agent",
          5: "/meta/send_media",
          6: "/meta/send_media",
          7: "/meta/send_media",
        };

        const url = urlMap[this.dataUserActiveChat.typeTicketId] || urlMap[1];

        // Send file and update status
        PbxHttpClient.post(url, payload)
          .then((res) => {
            // Replace temporary message with real one from server
            const messageIndex = this.messagesList.findIndex((group) =>
              group.some((msg) => msg.isTemp && msg.body === fileNameToSend),
            );

            if (messageIndex !== -1) {
              // Replace the temporary group with the real message from server
              this.messagesList.splice(messageIndex, 1, [generateListedMessage(res.data)]);
            }
          })
          .catch(() => {
            // In case of error, update temporary message with error status
            const messageIndex = this.messagesList.findIndex((group) =>
              group.some((msg) => msg.isTemp && msg.body === fileNameToSend),
            );

            if (messageIndex !== -1) {
              const tempMsg = this.messagesList[messageIndex][0];
              tempMsg.ack = -1; // Error status
              tempMsg.isTemp = false;
            }

            this.$snotify.error("No se pudo enviar la imagen.", "¡Error!");
          });

        this.resetIcon();
        this.clearMessage();
      } catch (error) {
        this.$snotify.error("No se pudo enviar la imagen.", "¡Error!");
      }

      this.$store.commit("layout/SET_OVERLAY", { value: false, title: "" });
      this.isSendingMessage = false;
    },

    /**
     * Sends an audio file to the corresponding endpoint according to the ticket type.
     * Attaches the audio as a file and processes it for different support channels.
     */
    async sendAudio() {
      this.$store.commit("layout/SET_OVERLAY", { value: true, title: "Enviando audio" });
      this.isSendingMessage = true;

      try {
        // Create audio file
        const currentDate = new Date().toISOString().replace(/[:.]/g, "-");
        const audioBlob = new Blob(this.audioChunks, { type: "audio/ogg" });
        const fileName = `grabacion_${currentDate}.mp3`;
        const audioFile = new File([audioBlob], fileName, {
          type: "audio/mp3",
        });

        // Create temporary message with sending status
        const tempMessage = {
          id: `temp_${Date.now()}`,
          body: "Nuevo audio",
          fromMe: 1,
          mediaType: "audio",
          mediaUrl: URL.createObjectURL(audioBlob),
          created_at: new Date().toISOString(),
          ack: 0, // Sending status (0 = clock)
          isTemp: true, // Mark to identify temporary messages
        };

        // Add temporary message to the list immediately
        this.messagesList.push([tempMessage]);

        // // Scroll to the end
        // this.$nextTick(() => {
        //   if (this.$refs.messageListVs) {
        //     this.$refs.messageListVs.scrollTo({ x: 0, y: "100%" });
        //   }
        // });

        // Build payload
        const payload = new FormData();
        payload.append("file", audioFile);
        payload.append("ticket_id", this.dataUserActiveChat.id);
        payload.append("mediaType", "audio");
        payload.append("type", "audio");
        payload.append("message", "Nuevo audio");

        // Endpoints by ticket type
        const endpoints = {
          1: "/whatsapps/send_media",
          3: "/telegram/send-image-agent",
          4: "/Ws_gupshup/send_image_agent",
          5: "/meta/send_media",
          6: "/meta/send_media",
          7: "/meta/send_media",
        };

        const endpoint = endpoints[this.dataUserActiveChat.typeTicketId];

        if (endpoint) {
          // Send audio and update status
          PbxHttpClient.post(endpoint, payload)
            .then(({ data }) => {
              // Replace temporary message with real one from server
              const messageIndex = this.messagesList.findIndex((group) =>
                group.some((msg) => msg.isTemp && msg.mediaType === "audio"),
              );

              if (messageIndex !== -1) {
                // Replace the temporary group with the real message from server
                this.messagesList.splice(messageIndex, 1, [generateListedMessage(data)]);
              }
            })
            .catch(() => {
              // In case of error, update temporary message with error status
              const messageIndex = this.messagesList.findIndex((group) =>
                group.some((msg) => msg.isTemp && msg.mediaType === "audio"),
              );

              if (messageIndex !== -1) {
                const tempMsg = this.messagesList[messageIndex][0];
                tempMsg.ack = -1; // Error status
                tempMsg.isTemp = false;
              }

              this.$snotify.error("No se pudo enviar el audio.", "¡Error!");
            });
        } else {
          this.$snotify.error("Tipo de ticket no soportado para envío de audio.", "¡Error!");
        }

        // Cleanup
        this.resetIcon();
        this.clearMessage();
        this.clearAudio();
      } catch (error) {
        this.$snotify.error("No se pudo enviar el audio.", "¡Error!");
      } finally {
        this.isSendingMessage = false;
        this.audioRecorderDialog = false;
        this.$store.commit("layout/SET_OVERLAY", { value: false, title: "" });

        // Stop audio stream if active
        if (this.audioStream) {
          this.audioStream.getTracks().forEach((track) => track.stop());
          this.audioStream = null;
        }
      }
    },

    async chatPreview(item, newMessage, automaticReload = false) {
      if (!automaticReload) this.isLoadingChat = true;

      if (this.isMobile) this.openChatPanelOnMobile();

      if (!newMessage) {
        this.selectedChat = item;
        const { id, contactId, contacts, typeTicketId, whatsappId } = item;
        const { name, profilePicUrl: avatar, whatsapp, phone1 } = contacts;

        this.dataUserActiveChat = {
          id,
          contactId,
          name,
          avatar,
          whatsapp,
          phone1,
          typeTicketId,
          whatsappId,
        };
        this.messagesList = [];
      }

      try {
        const { data: messages } = await PbxHttpClient.post(`/whatsapps/chat/index_chat`, {
          ticket_id: item.id,
        });
        if (!automaticReload) {
          const { ackData } = PbxHttpClient.post(`/chat/message_read_chat`, {
            ticket_id: item.id,
          });
          console.log(ackData);
        }
        const reversedMessages = Object.keys(messages)
          .reverse()
          .map((key) => messages[key]);

        // --- NEW: Keep temporary messages and only add new ones from server ---
        if (automaticReload) {
          // Only add new messages from server that don't already exist
          const currentIds = new Set();
          this.messagesList.forEach((group) =>
            group.forEach((msg) => {
              if (msg.id && !msg.isTemp) {
                currentIds.add(msg.id);
              }
            }),
          );

          // Filter only new messages from server
          const newServerMessages = reversedMessages.filter((group) => group.some((msg) => !currentIds.has(msg.id)));

          // Add only new messages at the end, keeping existing ones
          if (newServerMessages.length > 0) {
            this.messagesList = [...this.messagesList, ...newServerMessages];

            // Scroll to the end if there are new messages from server
            setTimeout(() => {
              if (this.$refs.messageListVs) {
                this.$refs.messageListVs.scrollTo({ x: 0, y: "100%" });
              }
            }, 500);
          }
        } else {
          // Initial load: use all messages from server
          this.messagesList = reversedMessages;
        }
        // --- END NEW ---

        this.mergeMessages();
        if (!automaticReload) this.activeChatsList = resetUnreadMessages(this.activeChatsList, item.id);
      } catch (err) {
        this.$snotify.error("No se pudo consultar el chat.");
      } finally {
        this.isLoadingChat = false;
        // this.getChatGallery();
      }
    },

    mergeMessages() {
      return this.messagesList.map((items) => {
        // Find the main element (the one that doesn't have mediaType "reaction")
        const mainItem = items.find((item) => item.mediaType !== "reaction");

        // Find the first reaction and add it to the main element
        const reaction = items.find((item) => item.mediaType === "reaction");
        if (reaction) {
          mainItem.reaction = reaction.body;
        }

        return mainItem;
      });
    },

    async handleNewMessage() {
      const { message, ticket, contacts } = this.newMessage.message;
      const isChatOpen = this.selectedActiveChat === ticket.id;

      if (isChatOpen) {
        this.messagesList.push([generateListedMessage(message)]);
        PbxHttpClient.post(`/whatsapps/chat/message_read_chat`, {
          ticket_id: ticket.id,
        });
      }

      const updateChatList = (list, updater) => list.map((el) => (el.id === ticket.id ? updater(el) : el));

      if (ticket.userId) {
        this.activeChatsList = updateChatList(this.activeChatsList, (el) =>
          generateUpdateListChat(el, ticket, message, isChatOpen),
        );
      } else {
        const chatExists = this.queueChatsList.some((el) => el.id === ticket.id);

        if (chatExists) {
          this.queueChatsList = updateChatList(this.queueChatsList, (el) =>
            generateUpdateQueueChat(el, ticket, message),
          );
        } else {
          this.queueChatsList.push(generateQueueListedChat(message, ticket, contacts));
        }
      }
    },

    /**
     * Toggles the visibility state of the quick message dialog.
     */
    toggleQuickMsgDialog() {
      this.getActiveChats(false);
      this.isOpenQuickMsgDialog = !this.isOpenQuickMsgDialog;
    },
  },
};
</script>

<style scoped>
/* Contenedor relativo para posicionar el botón absoluto */
.message-bubble-wrapper {
  position: relative;
}

/* El botón del menú (flecha) */
.message-menu-btn {
  position: absolute;
  top: 5px;
  right: 5px;
  z-index: 10;
  opacity: 0; /* Oculto por defecto */
  transition: opacity 0.2s ease-in-out;
  /* Fondo semitransparente para que se vea sobre imágenes */
  background-color: rgba(0, 0, 0, 0.3) !important;
  color: white !important;
  border-radius: 50%;
}

/* Mostrar el botón al hacer hover sobre la burbuja */
.message-bubble-wrapper:hover .message-menu-btn,
.message-menu-btn:focus-within, /* Mantener visible si el menú está abierto */
.v-menu__content--active {
  /* O si el menú está activo */
  opacity: 1;
}

.custom-list-item-title {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.replyMessage {
  display: -webkit-box; /* Utiliza un contenedor flexible */
  -webkit-box-orient: vertical; /* Define la orientación en vertical */
  -webkit-line-clamp: 3; /* Limita a 2 líneas */
  overflow: hidden; /* Oculta el desbordamiento */
  text-overflow: ellipsis; /* Agrega puntos suspensivos */
  white-space: normal; /* Permite el salto de línea */
}

.layout-default {
  height: 61.5vh;
}

.layout-replying {
  height: 50vh;
}
</style>
